import { render, staticRenderFns } from "./ProductivityReport.vue?vue&type=template&id=ec9dad52&"
import script from "./ProductivityReport.vue?vue&type=script&lang=js&"
export * from "./ProductivityReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports